import { render, staticRenderFns } from "./editDetail.vue?vue&type=template&id=32a366fb&scoped=true&"
import script from "./editDetail.vue?vue&type=script&lang=js&"
export * from "./editDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a366fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32a366fb')) {
      api.createRecord('32a366fb', component.options)
    } else {
      api.reload('32a366fb', component.options)
    }
    module.hot.accept("./editDetail.vue?vue&type=template&id=32a366fb&scoped=true&", function () {
      api.rerender('32a366fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/complaint-suggestion/modules/editDetail.vue"
export default component.exports